import React from 'react';
import styled from 'styled-components';
import { Flex, Text } from '@cko/primitives';
import { ErrorImage } from '../../../assets/ErrorImage';
const Image = styled.div `
  height: 208px;
  margin-top: var(--layout-shoe);
  width: 208px;
`;
const Issue = styled(Text) `
  font: var(--heading-md);
  margin: var(--layout-shoe) var(--layout-sandgrain) var(--layout-sandgrain);
`;
const Contact = styled(Text) `
  margin: var(--layout-shoe);

  a {
    color: var(--action-text-hover);
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const ErrorClient = () => {
    return (React.createElement(Flex, { flexDirection: "column", minHeight: "calc(100vh - 48px)" },
        React.createElement(Flex, { p: 0, flexDirection: "column", flexGrow: 1 },
            React.createElement(Flex, { minHeight: "100%", flexDirection: "column", alignItems: "center", justifyContent: "center", flexGrow: 1 },
                React.createElement(Image, { "data-testid": "account-error-image" },
                    React.createElement(ErrorImage, null)),
                React.createElement(Issue, null, "There is an issue with this client"),
                React.createElement(Contact, null,
                    "Please select another client or contact\u00A0",
                    React.createElement("a", { href: "mailto:support@checkout.com" }, "support@checkout.com"))))));
};
